import useReservationRestClient from "@app-rest/reservations";
import { IOfferQueryDate, IOfferQueryPagination, IOffersQuery, IReservationExtra } from "@app-rest/reservations.interfaces";
import { ref } from "vue";

const extras = ref<IReservationExtra[] | null> ([]);

export function useReservationExtras() {

	const syncExtras = async(query: IOffersQuery & IOfferQueryDate & Partial<IOfferQueryPagination>) => {
		const restClient = useReservationRestClient();
		const response = await restClient.extras(query);
		extras.value = response.data;
	}

	return {
		extras,
		syncExtras,
	}
}
